import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  MessageBox,
  SpacingVertical,
  SPACING_24,
  Spinner
} from 'mailup-web-components'

import styled from '@emotion/styled'

const SegmentationInfo = ({
  queued,
  simulationEnabled,
  simulationLoading,
  simulationLoaded,
  simulationResult,
  simulationDiff,
  handleSimulate
}) => {
  const intl = useIntl()

  return (
    <>
      <MessageBox variant='info' data-mu-test='modal-segmentation__info'>
        {intl.formatMessage({ id: 'Load.ModalSegmentation.Info' })}

        {simulationEnabled && (
          <div>
            <SpacingVertical variant={SPACING_24} />
            <StyledTable>
              <thead>
                <tr>
                  <StyledTableHead>
                    {intl.formatMessage({
                      id: 'Load.ModalSegmentation.RecipientsSelected'
                    })}
                  </StyledTableHead>
                  <StyledTableHead>
                    {intl.formatMessage({
                      id: 'Load.ModalSegmentation.RecipientsSameConditions'
                    })}
                  </StyledTableHead>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <StyledTableData>
                    {intl.formatNumber(queued)}{' '}
                    {intl.formatMessage({ id: 'Load.Common.SubscribersLower' })}
                  </StyledTableData>
                  <StyledTableData>
                    {simulationLoading && <Spinner />}
                    {!simulationLoading && (
                      <>
                        {!simulationLoaded && (
                          <p>
                            <a
                              data-mu-test='modalSegmentation-calculate-click'
                              href='#'
                              onClick={handleSimulate}
                            >
                              {intl.formatMessage({
                                id: 'Load.ModalSegmentation.Calculate'
                              })}
                            </a>
                          </p>
                        )}

                        {simulationLoaded && (
                          <>
                            {simulationDiff === 0 && (
                              <>
                                {intl.formatMessage({
                                  id: 'Load.ModalSegmentation.NoDiff'
                                })}
                              </>
                            )}

                            {simulationDiff !== 0 && (
                              <>
                                <p>{intl.formatNumber(simulationResult)}</p>
                                <p>
                                  {simulationDiff > 0 && '+ '}
                                  {simulationDiff < 0 && '- '}
                                  {intl.formatNumber(simulationDiff, {
                                    signDisplay: 'never'
                                  })}{' '}
                                  {intl.formatMessage({
                                    id: 'Load.Common.SubscribersLower'
                                  })}
                                </p>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </StyledTableData>
                </tr>
              </tbody>
            </StyledTable>
          </div>
        )}
      </MessageBox>
    </>
  )
}

export default SegmentationInfo

SegmentationInfo.propTypes = {
  queued: PropTypes.number,
  simulationEnabled: PropTypes.bool,
  simulationLoading: PropTypes.bool,
  simulationLoaded: PropTypes.bool,
  simulationResult: PropTypes.any,
  simulationDiff: PropTypes.number,
  handleSimulate: PropTypes.func
}

const CommonStyle = `
border: 1px solid var(--pure-white);
text-align: left;
vertical-align: top;
overflow: hidden;
padding: 24px 32px;
color: var(--pure-white);`

const StyledTable = styled.table`
  width: 100%;
`

const StyledTableHead = styled.th`
  ${CommonStyle}
  font-size: 14px;
  font-weight: 500;
  background-color: var(--java);
`

const StyledTableData = styled.td`
  ${CommonStyle}
  background-color: var(--picton-blue);
  font-weight: 400;
`
